import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { CommentLike } from '../../Pages';
import axiosConfig from "../../Service/axiosConfig"
import { PostFooter } from '../Post/PostFooter';
const autoLink = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`);
};
const CommentsList = ({ item }) => {
    const profile_data = JSON.parse(localStorage.getItem("profile_data"))
    const [Messages, SetMessages] = useState([]);
    const [count, setCount] = useState(0)
    const [page, setPage] = useState(1);
    const [chatMessage, setChatMessage] = useState("");
    const [parentMessage, setParentMessage] = useState(null);
    const textareaRef = useRef(null);
    useEffect(() => {
        if (textareaRef.current) {
            textareaRef.current.style.height = "auto"; // Reset height
            textareaRef.current.style.height = `${Math.min(
                textareaRef.current.scrollHeight,
                75
            )}px`;
        }
    }, [chatMessage]);
    const handlecommentReply = (message) => {
        console.log(message)
        setParentMessage(message);
        setChatMessage(`@${message.user.first_name} `);
    };
    const handleLoginShow = () => {
        document.querySelector('.login-text').click();
    }
    const GetComments = async () => {
        try {
            const response = await axiosConfig.get(`/accounts/comments/?modelimage=${item.id}&page_size=20&page=${page}`)
            setCount(Math.ceil(response.data.count / 20))
            if (page === 1) {
                SetMessages(response.data.results);
            } else {
                SetMessages([...Messages, ...response.data.results])
            }
        }
        catch (error) {
            console.log(error)
        }
    };
    const calculateTime = (endDate) => {
        const end = new Date(endDate);
        const now = new Date();
        const difference = now - end;
        const units = [
            { label: 'd', value: 24 * 60 * 60 * 1000 },
            { label: 'h', value: 60 * 60 * 1000 },
            { label: 'm', value: 60 * 1000 },
            { label: 's', value: 1000 }
        ];
        for (const unit of units) {
            const diffInUnit = Math.floor(difference / unit.value);
            if (diffInUnit > 0) {
                return `${diffInUnit}${unit.label}`;
            }
        }
        return 'just now';
    };
    const handleScroll = (e) => {
        const { clientHeight, scrollTop, scrollHeight } = e.target
        // console.log(clientHeight, scrollTop, scrollHeight)
        const tolerance = 5;
        if (clientHeight + scrollTop >= scrollHeight - tolerance && count > page) {
            setPage(prevPage => prevPage + 1);
        }
    }
    let Navigate = useNavigate()
    const handleNavigate = (link, type) => {
        Navigate(`/profile/${link}`);
    }
    const handleSendMessage = () => {
        const userName = parentMessage ? `@${parentMessage.user.first_name} ` : "";
        const messageToSend = chatMessage.startsWith(userName)
            ? chatMessage.replace(userName, "").trim()
            : chatMessage.trim();
        if (!messageToSend) return;
        const data_to_post = {
            content: messageToSend,
            modelimage: item.id,
            user: profile_data?.id,
            parent: parentMessage ? parentMessage.parent !== null ? parentMessage.parent : parentMessage.id : null
        }
        if (localStorage.getItem('token')) {
            axiosConfig.post(`/accounts/comments/`, data_to_post)
                .then(response => {
                    GetComments()
                    setPage(1)
                    setParentMessage(null);
                    setChatMessage("")
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            handleLoginShow();
        }
    };
    useEffect(() => {
        GetComments()
    }, [page, item])
    return (
        <div className='commentlist'>
            <div className="open-comments-desktop" onScroll={(e) => handleScroll(e)}>
                {Messages && Messages.filter(message => message.parent === null).map((message, index) => (
                    <div key={index}>
                        <div className="d-flex comment-list">
                            <div className="d-flex" style={{ gap: "10px" }}>
                                <div className="">
                                    <img
                                        onClick={() => handleNavigate(message?.user?.hcc_id)}
                                        src={message?.user?.profile_pic ? message?.user?.profile_pic : require("../Post/images/male.jpg")}
                                        className="comment-profile"
                                        alt={item?.profile?.full_name}
                                    />
                                </div>
                                <div className="comment-person">
                                    <div className="comment-detail">
                                        {message?.user?.first_name} <span dangerouslySetInnerHTML={{ __html: autoLink(message.content) }} />
                                    </div>
                                    <div className="reach">
                                        <span>{message.created_at && calculateTime(message.created_at)}</span>
                                        {/* <span>likes</span> */}
                                        <span onClick={() => handlecommentReply(message)}>Reply</span>
                                    </div>
                                </div>
                            </div>
                            <span>
                                <CommentLike productId={message.id} />
                            </span>
                        </div>
                        <div className="replies">
                            {Messages.filter(reply => reply.parent === message.id).map((reply, replyIndex) => (
                                <div className="d-flex comment-list reply-comment" key={replyIndex}>
                                    <div className="d-flex" style={{ gap: "10px" }}>
                                        <div className="">
                                            <img
                                                onClick={() => handleNavigate(reply?.user?.hcc_id)}
                                                src={reply?.user?.profile_pic ? reply?.user?.profile_pic : require("../Post/images/male.jpg")}
                                                className="comment-profile"
                                                alt={item?.profile?.full_name}
                                            />
                                        </div>
                                        <div className="comment-person">
                                            <div className="comment-detail">
                                                {reply?.user?.first_name} <span>{reply.content}</span>
                                            </div>
                                            <div className="reach">
                                                <span>{reply.created_at && calculateTime(reply.created_at)}</span>
                                                {/* <span>likes</span> */}
                                                <span onClick={() => handlecommentReply(reply)}>Reply</span>
                                            </div>
                                        </div>
                                    </div>
                                    <span>
                                        <CommentLike productId={reply.id} />
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className='comment-message'>
                <div className="post-footer-container-desktop">
                    <PostFooter item={item} />
                </div>
                <div className="post-new-comment">
                    <textarea ref={textareaRef} className="msg-text" rows={1} placeholder="Type a message..." value={chatMessage} onChange={(e) => setChatMessage(e.target.value)} style={{ resize: "none" }}
                    // onKeyPress={(e) => e.key === "Enter" && handleSendMessage()}
                    ></textarea>
                    {chatMessage && <div className="send-button" onClick={handleSendMessage}>Send</div>}
                </div>
            </div>
        </div >
    )
}

export { CommentsList }